import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { ArrowRightLeft, PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Snackbar } from "@mui/material";
import { Table, TableBody, TableCard, TableCell, TableHead, TableHeaderWrap, TableRow, TableFilterReturn, TableBuildingTag } from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import { TitleHeading } from "../../../../component/ui/layout";
import StockSupplyPopup from "../popup";
import StockSupplyMoveItemPopup from "../popup/move-item";
import { CategoryIcon, DateIcon, ItemIcon } from "../../../../component/icons/filter-icons";

const ItemAnalysis = () => {
  const apiCall = useApiCall();
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [dropdowns, setDropdowns] = useState({});
  const [tabIndex, setTabIndex] = useState(null);
  const [selectFilterName, setSelectFilterName] = useState('My Filter')
  const [editingFilters, setEditingFilters] = useState(null)
  const handleClose = () => { setAlertData({ isShow: false }); };
  const [invoiceList, setInvoiceList] = useState([]);
  const [addModal, setAddModal] = useState(false);

  useEffect(() => {
    getData({});
    getDropdowns()
  }, []);

  const getData = async ({ filter = filterReturn }) => {
    setIsLoading(true);
    let extraUrl = ``;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `${i === 0 ? "?" : "&"}${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `${i === 0 ? "?" : "&"}${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({ method: "get", url: `get-top-items-by-spending${extraUrl}` });
      setList(res.data);
      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getDropdowns = async () => {
    try {
      const [d1, d2] = await Promise.all([
        apiCall({ method: "get", url: "get-supply-dropdown-list" }),
        apiCall({ method: "get", url: "get-invoice-list" })
      ]);
      setDropdowns(d1?.data);
      setInvoiceList(d2?.data);
    } catch (error) {
      console.log("Error", error)
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setCurrentData({});
    setAddModal(false);
    setMoveItemModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "item_id",
      label: "Item",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.items,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: ItemIcon
    },
    {
      name: "date_range",
      label: "Date",
      options: ["between", 'contains', 'is'],
      selectedOpt: "contains",
      value: "",
      betweenType: "date",
      type: "date",
      isOpts: [
        {label: 'This Month', value: 'this_month'},
        {label: 'Last Month', value: 'last_month'},
        {label: 'This Year', value: 'this_year'},
        {label: 'Last Year', value: 'last_year'},
        {label: 'All Time', value: 'all_time'}
      ],
      Icon: DateIcon
    },
    {
      name: "category_id",
      label: "Category",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.categories,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: CategoryIcon
    },
  ];

  const editDetail = (ele) => {
    setTabIndex(0);
    setCurrentData(ele);
    setAddModal(true);
  };

  const [moveItemData, setMoveItemData] = useState(null);
  const [moveItemModal, setMoveItemModal] = useState(null);

  const moveItems = (ele) => {
    setMoveItemData(ele);
    setMoveItemModal(true);
  }

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={filterReturn}
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filters });
          }}
        />

        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Analysis`} />
          </span>

          <div className={Style.bpfl_action}>
            <div
              className={Style.bpfl_action}
              onClick={() => { setAddModal(true) }}
            >
              <Tooltip
                content={"Add Data"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                  <PlusIcon size={'1em'} />
                </div>
              </Tooltip>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          <TableCard>
            {isLoading ? (
              <InnerLoader />
            ) : !lists?.length ? (
              <div className="w-full h-full flex items-center justify-center">
                <DataNotFound title={"Purchasee Records"} />
              </div>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell header sticky>
                      <div className="flex gap-4 items-center">
                        <span>Item</span>
                      </div>
                    </TableCell>
                    {tableHeaders?.map((eachHead, index) =>
                      eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                        <TableCell header key={index}>
                          <TableHeaderWrap>
                            <span>{eachHead?.value}</span>
                          </TableHeaderWrap>
                        </TableCell>
                      ) : null
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {lists?.map((eachList, index) => {
                    return (
                      <TableRow key={`${index}`}>
                        <TableCell sticky>
                          <div className={`${Style.tableActionArea} !gap-4`}>
                            <div className="flex gap-[10px]">
                              <div className="flex items-center gap-3">
                                <div className="font-semibold text-[15px] leading-5">{eachList?.item_name ? eachList.item_name : "-"}</div>
                              </div>
                            </div>

                            {/* <div className={Style.tableActionAreaBtnGrpup}>
                              <div
                                className={
                                  "w-7 h-7 flex items-center cursor-pointer justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                }
                                onClick={() => {
                                  editDetail(eachList);
                                }}
                              >
                                <div
                                  className={Style.icon}
                                  style={{ color: "#FF9500" }}
                                >
                                  <NewEditIcon className="h-4.5 w-4.5" />
                                </div>
                              </div>

                              <div
                                className={
                                  "w-7 h-7 flex items-center cursor-pointer justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                }
                                onClick={() => {
                                  moveItems(eachList);
                                }}
                              >
                                <div
                                  className={Style.icon}
                                  style={{ color: "#007AFF" }}
                                >
                                  <ArrowRightLeft size={'1em'} />
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </TableCell>

                        {tableHeaders?.map((eachHead, i) =>
                          eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                            eachHead.key === "invoice_path" ? (
                              <TableCell
                                key={`${i}-${index}`}
                                className={`text-center`}
                              >
                                <a href={`${eachList?.invoice_path}`} rel="noopener noreferrer" target="_blank">view</a>
                              </TableCell>
                            ) : eachHead.key === "category_name" ? (
                              <TableCell key={`${i}-${index}`}>
                                <div className="flex flex-wrap gap-2 max-w-[550px]">
                                  <TableBuildingTag title={eachList[eachHead?.key]} colorIndex={dropdowns?.categories?.find((eachCat) => eachCat.name == eachList[eachHead?.key])?.id || 1} />
                                </div>
                              </TableCell>
                            ) : (
                              <TableCell key={`${i}-${index}`}>
                                {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                              </TableCell>
                            )
                          ) : null
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            )}
          </TableCard>
        </div>
      </div >

      {addModal &&
        <StockSupplyPopup
          currentData={currentData}
          onClose={() => { setAddModal(false); setCurrentData({}); setTabIndex(null); }}
          onError={onError}
          onSubmit={onSuccess}
          tabIndex={tabIndex}
          dropdowns={dropdowns}
        />
      }

      {moveItemModal && (
        <StockSupplyMoveItemPopup
          currentData={moveItemData}
          onClose={() => { setMoveItemModal(false); setMoveItemData({}); }}
          onError={onError}
          onSubmit={onSuccess}
          dropdowns={dropdowns}
        />
      )}

      {
        showModalFilterTable && (
          <DynamicFilter
            data={filterModalData}
            onClose={() => setShowModalFilterTable(false)}
            returnData={filterReturn}
            onSave={(filters, filterName, editingFilter) => {
              setShowModalFilterTable(false);
              setFilterReturn(filters);
              setSelectFilterName(filterName);
              setEditingFilters(editingFilter);
              getData({ filter: filters });
            }}
            selectFilterName={selectFilterName}
            editingFilters={editingFilters}
            saveFilter={saveFilter}
            apiUrl="get-top-items-by-spending"
          />
        )
      }

      {
        showModalCustomizeTabs && (
          <CustomizeTabsPopup
            data={tableHeaders}
            onClose={() => { setShowModalCustomizeTabs(false); }}
            onSave={(saveHeaders) => { setTableHeaders(saveHeaders); }}
            apiUrl="get-top-items-by-spending"
          />
        )
      }

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ItemAnalysis;